import { render, staticRenderFns } from "./salemanAmount.vue?vue&type=template&id=2ef096b4&"
import script from "./salemanAmount.vue?vue&type=script&lang=js&"
export * from "./salemanAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports